import React, { useState, useEffect, useRef } from "react";
import { Fab, Zoom, Typography, Box } from "@mui/material";
import { DownloadOutlined, InfoCircleOutlined, InfoOutlined, PlusCircleOutlined, VideoCameraAddOutlined } from "@ant-design/icons";
import menuIcon from "../../assests/Images/menu.svg";

const FloatingActionMenu = ({ onSelectImages, onShowInfo, onCreateVideo,onDownloadAll }) => {
  const [open, setOpen] = useState(false);
  const fabRef = useRef(null);

  const toggleFab = () => setOpen((prev) => !prev);

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        fabRef.current &&
        !fabRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const ActionButton = ({ icon, label, onClick, bottomOffset }) => (
    <Zoom in={open}>
      <Box
        sx={{
          position: "fixed",
          bottom: bottomOffset,
          right: 24,
          display: "flex",
          alignItems: "center",
          zIndex: 1200,
          cursor: "pointer"
        }}
        onClick={onClick}
      >
        <Box
          sx={{
            bgcolor: "white",
            color: "#005cff",
            borderRadius: "10px",
            width:"130px",
            px: 1.5,
            py: 0.5,
            mr: 1,
            boxShadow: 2,
            fontSize: 14,
          }}
        >
          <Typography>{icon} {label} </Typography>
        </Box>
        {/* <Fab color="primary" size="medium">

        </Fab> */}
      </Box>
    </Zoom>
  );

  return (
    <Box ref={fabRef}>
      {/* Action Buttons */}
      <ActionButton
        icon={<DownloadOutlined />}
        label="Download All"
        onClick={onDownloadAll}
        bottomOffset={175}
      />
      <ActionButton
        icon={<VideoCameraAddOutlined />}
        label="Create a Reel"
        onClick={onCreateVideo}
        bottomOffset={130}
      />
      <ActionButton
        icon={<InfoCircleOutlined />}
        label="How it works"
        onClick={onShowInfo}
        bottomOffset={85}
      />


      {/* Main FAB */}
      <Fab
        // color="primary"
        aria-label="main"
        onClick={toggleFab}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 10,
          zIndex: 2100,
          fontSize:25,
          color:"white",
          background:"#ff0080!important",
          transition: "transform 0.3s ease-in-out",
          transform: open ? "rotate(45deg)" : "rotate(0deg)",
        }}
      >
        {/* <PlusCircleOutlined /> */}
        <img src={menuIcon} width="40px" />
      </Fab>
    </Box>
  );
};

export default FloatingActionMenu;
